/**
 *
 * Asynchronously loads the component for InstallationInstructions
 *
 */

import { lazyLoad } from 'utils/loadable';

export const InstallationChannelSelector = lazyLoad(
  () => import('./index'),
  module => module.InstallationChannelSelector,
);
